import { NOT_REGISTERED } from '../../config';

/**
 * Stati possibili della licenza di un player.
 */
export const LICENCE_STATUS = {
    LIFETIME: 'lifetime',                       // licenza a vita attiva
    THREE_YEARS: 'threeYears',                  // licenza 3 anni attiva
    THREE_YEARS_EXPIRED: 'threeYearsExpired',   // licenza 3 anni scaduta
    INVALID: 'invalid'                          // nessuna licenza valida
};

export const LICENCE_STATUS_LABEL = {
    [LICENCE_STATUS.LIFETIME]: 'Lifetime attiva',
    [LICENCE_STATUS.THREE_YEARS]: 'Licenza 3 anni attiva',
    [LICENCE_STATUS.THREE_YEARS_EXPIRED]: 'Licenza 3 anni scaduta',
    [LICENCE_STATUS.INVALID]: 'Licenza non valida'
};

/**
 * Stato della licenza a partire dall'oggetto licence del player (o di una riga della pagina licenze).
 * Il tipo di licenza lo dice productName, che il BE manda sempre quando licence non è null.
 *
 * - licence null                => non valida
 * - productName con THREE-YEARS => 3 anni, attiva o scaduta in base a "expired"
 * - productName con LIFETIME    => lifetime attiva (se "expired" è true la considero non valida)
 * - qualsiasi altro prodotto    => non valida (es. le vecchie trial)
 *
 * @param {Object|null} licence
 */
export function licenceStatus(licence) {
    if (!licence) return LICENCE_STATUS.INVALID;

    const product = String(licence.productName || '').toUpperCase();

    if (product.includes('THREE-YEARS')) {
        return licence.expired ? LICENCE_STATUS.THREE_YEARS_EXPIRED : LICENCE_STATUS.THREE_YEARS;
    }

    if (product.includes('LIFETIME')) {
        return licence.expired ? LICENCE_STATUS.INVALID : LICENCE_STATUS.LIFETIME;
    }

    return LICENCE_STATUS.INVALID;
}

/**
 * true se la licenza è attiva (lifetime o 3 anni non scaduta).
 */
export const isLicenceActive = (licence) => [LICENCE_STATUS.LIFETIME, LICENCE_STATUS.THREE_YEARS].includes(licenceStatus(licence));

/**
 * true se la licenza ha un pagamento reale associato (lifetime o 3 anni, anche scaduta).
 */
export const hasLicencePayment = (licence) => !!licence && !!licence.paymentId && licence.paymentId !== NOT_REGISTERED;

/**
 * Motivo per cui un player non ha una licenza valida (usato nei tooltip).
 * Se licence è null ma c'è un licenceKey, il codice inserito non è valido.
 */
export function invalidLicenceReason(player) {
    if (!player || player.licence) return '';
    return player.licenceKey ? 'Codice non valido' : 'Nessuna licenza';
}
